var _style, _circle, _circle2, _circle3, _circle4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStressHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F31E2E;}\r\n\t.st1{fill:#001337;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 100.57,
    cy: 100,
    r: 90.14
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 100.41,
    cy: 100.97,
    r: 79.52
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 63.39,
    cy: 77.46,
    r: 11.59
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 137.43,
    cy: 77.79,
    r: 11.59
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.31,132.84l67.93-11.91c0,0,6.28-1.29,7.4,4.35c0.32,1.29,0.8,5.31-4.99,6.76 c-7.89,1.45-68.57,11.91-68.57,11.91s-5.47,1.77-7.08-4.02C55.16,139.76,54.04,133.96,60.31,132.84z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressHigh);
export default __webpack_public_path__ + "static/media/StressHigh.21fb949399e05c7e5d497c0a43c4c95d.svg";
export { ForwardRef as ReactComponent };